export default __webpack_public_path__ + "6bfcffc8b5489f2284be62a80e68acf3.png";